import ModuleContainer from './components/AxpSuppRoot';
import './iguazu-rest/config';
import './iguazu-rpc/config';
import memberProducts from './memberProducts';

memberProducts();

export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x",
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    'axp-product-ducks': { version: '0.3.3', module: require('axp-product-ducks')},
  '@americanexpress/product-ducks': { version: '1.3.3', module: require('@americanexpress/product-ducks')},
  'iguazu': { version: '3.2.0', module: require('iguazu')},
  'iguazu-holocron': { version: '1.3.0', module: require('iguazu-holocron')},
  'iguazu-rest': { version: '1.10.2', module: require('iguazu-rest')},
  'iguazu-rpc': { version: '1.6.1', module: require('iguazu-rpc')},
  '@americanexpress/one-experiments': { version: '2.1.1', module: require('@americanexpress/one-experiments')},
  '@americanexpress/myca-essentials': { version: '3.3.0', module: require('@americanexpress/myca-essentials')},
  '@americanexpress/react-ddl': { version: '0.1.4', module: require('@americanexpress/react-ddl')},
  'iguazu-graphql': { version: '1.3.0', module: require('iguazu-graphql')},
  'dayjs': { version: '1.11.13', module: require('dayjs')},
  '@americanexpress/reactlytics': { version: '1.2.7', module: require('@americanexpress/reactlytics')},
  '@emotion/core': { version: '10.1.1', module: require('@emotion/core')},
  },
});

if(global.getTenantRootModule === undefined || (global.rootModuleName && global.rootModuleName === 'axp-card-member-apply-root')){
global.getTenantRootModule = () => ModuleContainer;
global.rootModuleName = 'axp-card-member-apply-root';
}
